import { CompanyRfuModelType } from 'generated/graphql';

export const rfuModelTypeRadioButtonOptions = [
  {
    id: 'value-based',
    label: 'Value based',
    value: CompanyRfuModelType.ValueBased,
  },
  {
    id: 'behaviour-based',
    label: 'Behaviour based',
    value: CompanyRfuModelType.BehaviourBased,
  },
];

export const dataTestId = 'role-skills-profile-form';
